import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-mail-box-icon',
  templateUrl: './communication-mail-box.component.html'
})
export class CommunicationMailBoxComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
